import { Injectable } from '@angular/core';

export type PublicCartItem = {
  cardId: string;
  cardName: string;
  position: number;
  price: number;
};

const STORAGE_KEY = 'public_cart_items';

@Injectable({
  providedIn: 'root',
})
export class PublicCartService {
  private items: PublicCartItem[] = [];

  constructor() {
    this.clearLegacySharedStorage();
    this.items = this.load();
  }

  getItems(): PublicCartItem[] {
    return [...this.items];
  }

  addItem(item: PublicCartItem): void {
    const exists = this.items.some(
      (entry) => entry.cardId === item.cardId && entry.position === item.position
    );
    if (exists) return;
    this.items = [...this.items, item];
    this.persist();
  }

  removeItem(cardId: string, position: number): void {
    this.items = this.items.filter(
      (entry) => !(entry.cardId === cardId && entry.position === position)
    );
    this.persist();
  }

  clear(): void {
    this.items = [];
    this.persist();
  }

  private load(): PublicCartItem[] {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private persist(): void {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
      this.clearLegacySharedStorage();
    } catch {
      // ignore storage errors
    }
  }

  private clearLegacySharedStorage(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore storage errors
    }
  }
}
